import {InMemoryCache} from 'apollo-cache-inmemory';

const cache = new InMemoryCache();

cache.writeData({
  data: {
    estatusNotificaciones: {
      __typename: 'EstatusNotification',
      permiso: 'default',
      esCompatible: !('serviceWorker' in navigator)
        ? false : !('PushManager' in window)
        ? false : true,
      existeSuscripcion: false,
    },
  },
});

export {cache};
